import React from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import TrainingModalitiesList from './TrainingModalitiesList';

const TrainingModalitiesSettingsPage: React.FC = () => {
    const pageHeader = {
        title: 'Modalidades',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Administración' },
            { name: 'Configuración General' },
            { name: 'Modalidades', href: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.trainingModalities },
        ]
    };

    return (
        <div className='h-full overflow-auto scrollbar'>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
                className='border-b-4 border-dotted border-grey-500 top-0'
            />
            <div className="p-6">
                <TrainingModalitiesList />
            </div>
        </div>
    );
};

export default TrainingModalitiesSettingsPage;
